export default __webpack_public_path__ + "static/media/past-blue.545216c3.svg";